var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { pages, url } from "@recoil/Store";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useEffect } from "react";
import * as Const from "@utils/Const";
import Pagenation from "@components/common/Pagenation";
import Main from "../../Main";
export default function Faq(props) {
    const [urls, setUrl] = useRecoilState(url);
    return (_jsxs(_Fragment, { children: [_jsx(Main, {}), (urls) && _jsx(View, { url: urls, setUrl: setUrl })] }));
}
function View(props) {
    const { url, setUrl } = props;
    const location = useLocation();
    const navigate = useNavigate();
    let pageInfo = useRecoilValue(pages);
    const [page, setPage] = useState(pageInfo);
    const [list, setList] = useState([]);
    const [items, setItems] = useState(null);
    const [search, setSearh] = useState("");
    const [searchApi, setSearhApi] = useState("");
    let boardType = url.depth2.menuName;
    function handlePage(pages) {
        setPage(Object.assign(Object.assign({}, page), { pageNum: pages - 1 }));
    }
    const lang = localStorage.getItem(Const.LANG_TYPE);
    let appPath = `?page=${page.pageNum}&size=${page.size}`;
    if (searchApi.length > 0)
        appPath = appPath + `&search=${searchApi}`;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/board/${boardType}/detail?lang=KOR`,
        appQuery: {},
        userToken: "",
        watch: appPath,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                List(data.body);
            }
        }
    }, [data]);
    const List = (board) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_GET,
            appPath: `/open/board/${board.boardId}/list${appPath}`,
            appQuery: {},
            userToken: "",
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                sessionStorage.setItem("boardId", board.boardId);
                setList(data.body);
                setPage(Object.assign(Object.assign({}, data.data.page), { totalPages: Math.ceil(data.data.page.totalElements / page.size) }));
            }
            else {
            }
        }
    });
    //엔터검색
    function Search(e) {
        if (e.key == "Enter") {
            setSearhApi(e.target.value);
            handlePage(0);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "notice-section" }, { children: [_jsxs("div", Object.assign({ className: "notice-header" }, { children: [_jsx("h2", { children: "FAQ" }), _jsxs("div", Object.assign({ className: "search-box" }, { children: [_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "21", viewBox: "0 0 20 21", fill: "none" }, { children: _jsx("path", { d: "M20 18.278L14.2739 12.5519C15.3325 10.943 15.7565 8.9986 15.4638 7.09509C15.1711 5.19158 14.1825 3.46437 12.6894 2.24789C11.1964 1.0314 9.3051 0.412159 7.3817 0.510063C5.45831 0.607966 3.63966 1.41605 2.27785 2.77785C0.916047 4.13966 0.107966 5.95831 0.0100628 7.8817C-0.0878409 9.8051 0.531397 11.6964 1.74789 13.1894C2.96437 14.6825 4.69158 15.6711 6.59509 15.9638C8.4986 16.2565 10.443 15.8325 12.0519 14.7739L17.778 20.5L20 18.278ZM2.22389 8.27892C2.22389 5.21588 4.71588 2.72389 7.77892 2.72389C10.842 2.72389 13.334 5.21588 13.334 8.27892C13.334 11.342 10.842 13.834 7.77892 13.834C4.71588 13.834 2.22389 11.342 2.22389 8.27892Z", fill: "#666666" }) })), _jsx("input", { type: "text", placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", value: search, onChange: (e => setSearh(e.target.value)), onKeyDown: (e) => Search(e) })] }))] })), (list.length > 0) && list.map((item, idx) => (_jsxs("details", { children: [_jsxs("summary", { children: [_jsx("span", Object.assign({ className: "label-q" }, { children: "Q." })), item.title] }), _jsxs("div", Object.assign({ className: "faq-answer" }, { children: [_jsx("span", Object.assign({ className: "label-a" }, { children: "A." })), item.content] }))] })))] })), _jsx(Pagenation, { page: page, handlePage: handlePage })] }));
}
